import { useMemo, useState } from 'react';
import { TransactionType } from '../../enums';
import { useFormatReceipt } from '../useFormatReceipt';
import { useGetBilletReceipt } from '../useGetBilletReceipt';
import { useGetP2PReceipt } from '../useGetP2PReceipt';
import { useGetPixReceipt } from '../useGetPixReceipt';
import { useGetTedReceipt } from '../useGetTedReceipt';
export function useGetReceipt() {
    const { fromPixReceiptToReceipt, fromBilletReceiptToReceipt, fromTedReceiptToReceipt, fromP2PReceiptToReceipt } = useFormatReceipt();
    const { error: errorPix, loading: loadingPix, pixReceipt, getPixReceipt } = useGetPixReceipt();
    const { error: errorBillet, loading: loadingBillet, billetReceipt, getBilletReceipt } = useGetBilletReceipt();
    const { error: errorTed, loading: loadingTed, tedReceipt, getTedReceipt } = useGetTedReceipt();
    const { error: errorP2P, loading: loadingP2P, p2pReceipt, getP2PReceipt } = useGetP2PReceipt();
    const [typeError, setTypeError] = useState(false);
    const error = useMemo(() => errorPix || errorBillet || errorTed || errorP2P || typeError, [errorPix, errorBillet, errorTed, errorP2P, typeError]);
    const loading = useMemo(() => loadingPix || loadingBillet || loadingTed || loadingP2P, [loadingPix, loadingBillet, loadingTed, loadingP2P]);
    const receipt = useMemo(() => {
        if (pixReceipt) {
            return fromPixReceiptToReceipt(pixReceipt);
        }
        if (billetReceipt) {
            return fromBilletReceiptToReceipt(billetReceipt);
        }
        if (tedReceipt) {
            return fromTedReceiptToReceipt(tedReceipt);
        }
        if (p2pReceipt) {
            return fromP2PReceiptToReceipt(p2pReceipt);
        }
    }, [pixReceipt, billetReceipt, tedReceipt, p2pReceipt]);
    const getReceipt = (transactionId, transactionType, transactionFlow, coreBankId, instructionFlow) => {
        const action = {
            [TransactionType.PIX]: () => getPixReceipt(transactionId, transactionFlow, instructionFlow),
            [TransactionType.BILLET]: () => getBilletReceipt(transactionId, transactionFlow, coreBankId, instructionFlow),
            [TransactionType.TED]: () => getTedReceipt(transactionId),
            [TransactionType.P2P]: () => getP2PReceipt(transactionId, coreBankId),
        }[transactionType];
        if (action) {
            action();
        }
        else {
            setTypeError(true);
        }
    };
    return {
        receipt,
        error,
        loading,
        getReceipt,
    };
}
